import { render, staticRenderFns } from "./GiftChart.vue?vue&type=template&id=a4095894&"
import script from "./GiftChart.vue?vue&type=script&lang=js&"
export * from "./GiftChart.vue?vue&type=script&lang=js&"
import style0 from "./GiftChart.vue?vue&type=style&index=0&id=a4095894&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports